import { lazy, Suspense } from "react";

import Login from "./Login";

const ForgotPassword = lazy(() => import("./ForgotPassword"));
const Error404 = lazy(() => import("./Error"));

const sessionsRoutes = [
  {
    path: "/signin",
    element: (
      <Suspense>
        <Login />
      </Suspense>
    ),
  },
  {
    path: "/sessions/forgot-password",
    element: (
      <Suspense>
        <ForgotPassword />
      </Suspense>
    ),
  },
  {
    path: "/sessions/404",
    element: (
      <Suspense>
        <Error404 />
      </Suspense>
    ),
  },
];

export default sessionsRoutes;
